import { googleSiteVerification } from '@pkg/config/misc/googleSiteVerification';
import type { Preload } from '~/app/helpers/resourceHints';

const sanityProjectId = process.env.NUXT_SANITY_PROJECT_ID ?? process.env.NUXT_PUBLIC_SANITY_PROJECT_ID;

export default defineAppConfig({
  icon: {
    mode: 'svg',
    size: '1em',
    class: '',
    // CMS icons ship with hard-coded fills, which prevents them from inheriting
    // the surrounding theme color (e.g. `--tile-icon-color`). Rewrite those fills
    // to `currentColor` so every icon is themed via its `color`, like before the
    // icon-library migration.
    customize(content: string, _name: string, prefix: string) {
      if (prefix === 'cms') {
        return content
          .replace(/(fill|stroke)="#[0-9a-fA-F]{3,8}"/g, '$1="currentColor"')
          .replace(/(fill|stroke):\s*#[0-9a-fA-F]{3,8}/g, '$1: currentColor');
      };
    },
  },
  meta: {
    name: 'Too Good To Go',
    title: 'Join Our Food Waste Movement',
    description: 'The app that lets customers rescue unsold food from shops and restaurants to save it from going to waste. Try it today.',
    originalCopyrightYear: '2024',
    googleSiteVerification,
  },
  preconnect: [
    'https://cdn.sanity.io',
    ...(sanityProjectId ? [`https://${sanityProjectId}.apicdn.sanity.io`] : []),
    'https://player.vimeo.com',
  ] as Array<string>,
  preload: [] as Array<Preload>,
});
